import { Dialog, Transition } from "@headlessui/react";
import XIcon from "@heroicons/react/solid/XIcon";
import React, { FC, Fragment } from "react";
import { Settings } from "react-slick";

import ResponsiveSlider from "@components/common/responsive-slider";

interface Props {
  show: boolean;
  hide(): void;
  customPaging(index: number): JSX.Element;
  initialSlide: number;
}

const ImageCarousel: FC<Props> = ({
  children,
  initialSlide,
  customPaging,
  show,
  hide,
}) => {
  const settings: Settings = {
    customPaging,
    initialSlide,
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    slidesToShow: 1,
    className: "h-full image-slider",
  };

  return (
    <Transition show={show} as={Fragment}>
      <Dialog
        className="fixed z-50 inset-0 overflow-y-auto"
        onClose={() => hide()}
      >
        <Dialog.Overlay className="bg-black opacity-80 fixed inset-0" />
        <Transition.Child
          as={Fragment}
          enter="transition origin-left duration-300 ease-out"
          enterFrom="scale-90 opacity-0"
          enterTo="scale-100 opacity-100"
          leave="transition origin-left duration-100 ease-in"
          leaveFrom="scale-100 opacity-100"
          leaveTo="scale-90 opacity-0"
        >
          <div className="w-full h-full">
            <div className="absolute top-4 md:top-10 right-4 md:right-10 w-10 h-10 z-20">
              <button
                className="w-full h-full focus:outline-none"
                onClick={() => hide()}
              >
                <XIcon className="text-white" />
              </button>
            </div>
            <div className="h-full w-full overflow-hidden">
              <ResponsiveSlider {...{ settings }} breakpoints={{ base: 1 }}>
                {children}
              </ResponsiveSlider>
            </div>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};

export default ImageCarousel;
